import React, { useRef, useState } from 'react';
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import AiSoraVideo from '../animations/ai-sora-video/AiSoraVideo';
import AiClip from '../animations/ai-clip/AiClip';
import AiVideoAd from '../animations/ai-video-ad/AiVideoAd';
import AiAvatarVideo from '../animations/ai-avatar-video/AiAvatarVideo';
import SliderCard from './SliderCard';

export default function SliderSection({ slides, style, title, text, handleClick, isVisible, column }) {
    const swiperRef = useRef(null);


    const [activeIndex, setActiveIndex] = useState(0);

    const goPrev = () => swiperRef.current?.slidePrev();
    const goNext = () => swiperRef.current?.slideNext();
    const goTo = (index) => swiperRef.current?.slideToLoop(index);

    return (
        <div className='landing-slider' style={style} data-theme="light">
            <div className="landing-container">
                <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
                <p>{text}</p>

                {isVisible ? <>
                    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${column}, 1fr)`, gridColumnGap: '24rem', gridRowGap: '60rem' }}>
                        {slides.map((slide, i) => (
                            <div className="landing-slider-item">
                                <SliderCard key={i} handleClick={handleClick} animation={slide.animation} img={slide.img} title={slide.title} text={slide.text} source={slide.source} />
                            </div>
                        ))}
                    </div>
                </> :
                    <> <Swiper
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                        spaceBetween={20}
                        slidesPerView={1.1}
                        // loop={true}
                        // autoplay={{
                        //     delay: 5000,
                        //     disableOnInteraction: false,
                        // }}
                        modules={[Autoplay]}
                    >
                        {slides.map((slide, i) => (
                            <SwiperSlide key={i}>
                                <SliderCard handleClick={handleClick} animation={slide.animation} img={slide.img} title={slide.title} text={slide.text} source={slide.source} />
                            </SwiperSlide>
                        ))}
                    </Swiper>


                        <div className='landing-slider-nav'>
                            <button onClick={goPrev}>
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.60989 3.54991C9.88027 3.81648 9.90563 4.23771 9.68399 4.53326L9.61741 4.61054L5.04167 9.25065L16.75 9.25065C17.1642 9.25065 17.5 9.58644 17.5 10.0007C17.5 10.383 17.2139 10.6985 16.8441 10.7448L16.75 10.7507H5.04167L9.61741 15.3908C9.88399 15.6611 9.90337 16.0827 9.67755 16.3751L9.60989 16.4514C9.33951 16.718 8.91796 16.7374 8.62558 16.5115L8.54926 16.4439L2.71592 10.5272C2.45202 10.2595 2.43003 9.84306 2.64995 9.55058L2.71592 9.4741L8.54926 3.55743C8.84006 3.26247 9.31493 3.2591 9.60989 3.54991Z" fill={`${activeIndex === 0 ? '#8F969C' : 'black'}`} />
                                </svg>

                            </button>
                            <div className='landing-slider-nav__pagination'>
                                {slides.map((_, i) => (
                                    <div
                                        key={i}
                                        onClick={() => goTo(i)}
                                        style={{

                                            borderRadius: '50%',
                                            background: i === activeIndex ? '#000' : 'rgba(0, 0, 0, 0.1)',
                                            cursor: 'pointer',
                                        }}
                                    />
                                ))}
                            </div>
                            <button onClick={goNext}><svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.3901 3.54991C10.1197 3.81648 10.0944 4.23771 10.316 4.53326L10.3826 4.61054L14.9583 9.25065L3.25 9.25065C2.83579 9.25065 2.5 9.58644 2.5 10.0007C2.5 10.383 2.78611 10.6985 3.15592 10.7448L3.25 10.7507H14.9583L10.3826 15.3908C10.116 15.6611 10.0966 16.0827 10.3224 16.3751L10.3901 16.4514C10.6605 16.718 11.082 16.7374 11.3744 16.5115L11.4507 16.4439L17.2841 10.5272C17.548 10.2595 17.57 9.84306 17.3501 9.55058L17.2841 9.4741L11.4507 3.55743C11.1599 3.26247 10.6851 3.2591 10.3901 3.54991Z" fill={`${activeIndex === slides.length - 1 ? '#8F969C' : 'black'}`} />
                            </svg>
                            </button>
                        </div>
                    </>}

            </div>
        </div>
    );
}
